import { useEffect, useState } from "react";
import { getSymbolById } from "../utils/symbolTypes";

/**
 * The editor's 顯示 layers (基站, 物件, 可行區域, 越線): view-only, the same
 * as the dashboard's. Nothing here is saved; every open starts with all of
 * them shown. `show` is for a tool, which always brings its own layer back.
 */
const ALL_SHOWN = Object.freeze({
  stations: true,
  symbols: true,
  area: true,
  tripwires: true,
});

export const useEditorLayers = (open) => {
  const [visible, setVisible] = useState(ALL_SHOWN);

  useEffect(() => {
    if (open) setVisible(ALL_SHOWN);
  }, [open]);

  return {
    visible,
    toggle: (key) => setVisible((v) => ({ ...v, [key]: !v[key] })),
    show: (key) => setVisible((v) => (v[key] ? v : { ...v, [key]: true })),
  };
};

/**
 * The 顯示 rows for one layout, in LayerControls' `toggles` shape. Only a
 * plane site draws a walkable area, so line and tunnel have no 可行區域 row.
 * An area still being drawn counts as one.
 */
export const editorLayerToggles = ({
  layoutType,
  visible,
  onToggle,
  placedStations,
  placedSymbols,
  areaVertices,
  tripwires,
}) => {
  const symbolCount = placedSymbols.filter((s) =>
    getSymbolById(s.symbol_type)?.compatibleLayouts?.includes(layoutType),
  ).length;
  const rows = [
    ["基站", "stations", placedStations.length],
    ["物件", "symbols", symbolCount],
    layoutType === "plane" && [
      "可行區域",
      "area",
      areaVertices.length > 0 ? 1 : 0,
    ],
    ["越線", "tripwires", tripwires.length],
  ].filter(Boolean);
  return rows.map(([label, key, count]) => ({
    label,
    count,
    visible: visible[key],
    onToggle: () => onToggle(key),
  }));
};
